module.exports = __webpack_public_path__ + "static/media/fundTransfer.b52cb8a7.svg";